<template>
  <div class="wh100">
    <MyPanel class="myPanel" :title="'功能区列表'">
      <MyTable
        :url="tableUrl"
        :params="form"
        ref="myTable"
        :customSort="true"
        :index-column="true"
        border
        fit
      >
        <template slot="columns">
          <el-table-column
            prop="Area3"
            label="三级区"
            align="center"
            sortable
          ></el-table-column>
          <el-table-column
            prop="FunctionName"
            label="功能区名称"
            align="center"
            sortable
          ></el-table-column>
          <el-table-column
            prop="Scope"
            label="范围"
            align="center"
            sortable
          ></el-table-column>
          <el-table-column
            prop="RiverLength"
            label="长度"
            width="100"
            align="center"
            sortable
          ></el-table-column>
          <el-table-column
            prop="WhereInflows"
            label="流入何处"
            align="center"
            sortable
          ></el-table-column>
          <el-table-column
            prop="FunctionBy"
            label="划分依据"
            width="100"
            align="center"
            sortable
          ></el-table-column>

          <el-table-column
            prop="CurWaterLevel"
            label="当前水质"
            width="100"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.CurWaterLevel >= 1"
                :style="{
                  color: $util.getLevelColor(scope.row.CurWaterLevel),
                }"
              >
                {{ $util.getLevel(scope.row.CurWaterLevel) }}</span
              >
              <span v-else style="">--</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="TargetWaterLevel"
            label="目标水质"
            width="100"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.TargetWaterLevel >= 1"
                :style="{
                  color: $util.getLevelColor(scope.row.TargetWaterLevel),
                }"
              >
                {{ $util.getLevel(scope.row.TargetWaterLevel) }}</span
              >
              <span v-else style="">--</span>
            </template>
          </el-table-column>
        </template>
      </MyTable>
    </MyPanel>
  </div>
</template>

<script>
import LayoutCorner from "../../../../components/layout/LayoutCorner";
import MyChart from "../../../../components/EChart";
import MyPanel from "../../../../components/Pannel/Pannel";
import MyTable from "../../../../components/PageTable";
export default {
  components: {
    LayoutCorner,
    MyChart,
    MyPanel,
    MyTable,
  },
  props: {
    riverName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        RiverName: "",
      },
      tableUrl: "/Map/GetRiverDetails",
    };
  },
  methods: {
    loadData() {
      let that = this;
      that.form.RiverName = that.riverName;
      that.$refs.myTable.reload();
    },
    getStationData() {
      let that = this;
      that.$api.get(
        "/Station/GetStationByName",
        {
          stationName: that.stationName,
        },
        function (res) {
          if (res.code == 200) {
            if (res.data.length > 0) {
              that.ControlUnitName = res.data[0].ControlUnitName;
              that.StationType = res.data[0].StationType;
              that.WaterName = res.data[0].WaterName;
              that.CityName = res.data[0].CityName;
              that.CountyName = res.data[0].CountyName;
            }
          }
        },
        function () {},
        true
      );
    },
  },

  mounted() {},
  watch: {},
};
</script>
<style lang="less" scoped>
/deep/ .myPanel {
  background: rgba(1, 174, 222, 0.13);
  padding: 1rem;
  border: unset;
  .title-container {
    border-bottom: 0px solid #e3e3e3;
  }
  .content-container {
    background: rgba(1, 174, 222, 0.1);
    border: 1px dashed rgba(1, 174, 222, 0.3);
    line-height: 1.5rem;
    padding: 1rem;
  }
  .el-table,
  .mytable {
    background: unset;
    color: #00e4ff;
  }
  .el-table th,
  .el-table tr {
    background: rgba(0, 0, 0, 0.15);
  }
  .el-loading-mask {
    background: unset;
  }
  .el-table--border,
  .el-table--group {
    border: 0px solid #ebeef5;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 0px solid #1e2c4c;
  }
  .el-table__header thead tr th {
    color: #0c717c;
  }
  .el-table--border td,
  .el-table--border th,
  .el-table__body-wrapper
    .el-table--border.is-scrolling-left
    ~ .el-table__fixed {
    border-right: 0px solid #ebeef5;
  }
  .el-table--border,
  .el-table--group {
    border-left: 1px solid rgba(1, 174, 222, 0.3);
  }
  .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: rgba(1, 174, 222, 0.3);
  }
  .el-input__inner {
    background: rgba(0, 0, 0, 0.5);
  }
  .el-pagination .btn-prev {
    background: rgba(0, 0, 0, 0.5);
  }
  .el-pagination .btn-next {
    background: rgba(0, 0, 0, 0.5);
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    //background-color: #000;
    background: rgba(0, 0, 0, 0.15);
  }
}
</style>